/* eslint-disable max-len */
const translations = {
  AddCourseToClassModal: {
    noNewSelectedCourses: 'No new selected content yet.',
    selectCourses: 'Select Content',
    selectedCourses: 'Selected Content'
  },
  AdditionalResourcePills: {
    autoScored: 'Auto-Graded',
    manualScored: 'Manually Graded',
  },
  AdminClassroomsView: {
    allCourses: 'All Content',
    courseDropdownLabel: 'Content:'
  },
  AggregateAssignmentCard: {
    course: '',
    gradebookLabel: 'Grade Review'
  },
  AssessmentItemFilter: {
    allCourses: 'All Content',
    course: 'Content'
  },
  AssignmentCard: {
    gradebookLabel: 'Grade Review'
  },
  AssignmentMenu: {
    AssignmentLabel: 'Assignments',
  },
  AssignmentView: {
    assignedToColumnLabel: 'Assigned To',
    gradebookLabel: 'Grade Review',
    scorecardColumnLabel: 'Grade Review',
  },
  AssignmentsPopup: {
    gradebookLabel: 'Grade Review'
  },
  Button: {
    addCourseButton: '+ Add Content'
  },
  ClassCard: {
    course: 'Content',
    courseLabel: 'Content',
    coursesLabel: 'Content',
    workspace: 'FileShare'
  },
  ClassCourses: {
    BannerTitle: 'Content',
    InitialBreadcrumb: 'Content',
    InitialBreadcrumb_plural: 'Content',
  },
  ClassDetails: {
    BannerTitle: 'Content',
  },
  ClassWorkspace: {
    WorkspaceLabel: 'FileShare',
    workspaceTitle: 'FileShare',
  },
  ContentAssignmentModal: {
    gradebookLabel: 'Grade Review',
  },
  ContentElementModal: {
    gradebookLabel: 'Grade Review',
  },
  CourseElementModal: {
    gradebookLabel: 'Grade Review',
  },
  CourseTreeLeaf: {
    teacherButtonGradebook: 'Grade Review'
  },
  CourseLayout: {
    gradebookLabel: 'Grade Review'
  },
  CourseListBanner: {
    progressLabel: 'Progress'
  },
  DemolinkLauncherView: {
    demoUserFirstName: 'Ignite',
    demoUserLastName: 'Instructor',
  },
  FileViewerModal: {
    gradebookLabel: 'Grade Review'
  },
  Gradebook: {
    gradebookLabel: 'Grade Review',
  },
  GradebookHeader: {
    goToCourseLabel: 'Go To Content'
  },
  LearnosityPrintPreview: {
    gradebookLabel: 'Grade Review'
  },
  LearnosityScoringModal: {
    gradebookLabel: 'Grade Review'
  },
  Login: {
    helpAndQuestions: 'Help & Questions',
    loginLogoLabel: 'Logo: G-W Ignite. Skillful Digital Learning',
    registerButtonExplanation: 'Accessing a course for the first time?',
    username: 'Email'
  },
  MainView: {
    readOnlyGradebookCautionBannerMsg: 'As an Administrator, the grade review is read only. To make changes, consult with the teacher or switch roles if you also have teacher permissions.'
  },
  NavigationService: {
    InitialBreadcrumb: 'Content',
    InitialBreadcrumb_plural: 'Content',
    gradebookLabel: 'Grade Review'
  },
  ProgressView: {
    BannerTitle: 'Progress',
    highText: 'Meeting',
    lowText: 'Developing',
    mediumText: 'Approaching'
  },
  Register: {
    registration: 'Registration'
  },
  StudentAssignmentCard: {
    course: ''
  },
  StudentDashboard: {
    AssignmentLabel: 'Assignments',
    BookLabel: 'Content',
    NoAssignmentsYet: 'No assignments yet',
    WelcomeLabel: ' Welcome'
  },
  StudentHelperService: {
    progressSummaryLegendHighLabel: 'Meeting',
    progressSummaryLegendLowLabel: 'Developing',
    progressSummaryLegendMediumLabel: 'Approaching'
  },
  StudentTopNav: {
    AssignmentLabel: 'Assignments',
    BookLabel: 'Content',
    DashboardLabel: 'Dashboard',
    ProgressLabel: 'Progress',
    WorkspaceLabel: 'FileShare'
  },
  TeacherDashboard: {
    gradebookLabel: 'Grade Review',
  },
  TrialEnterPurchaseCodesModal: {
    findAndPurchaseLabel: 'Locate and Purchase Access',
    findAndPurchaseUrl: 'https://www.g-w.com/ignite'
  },
  Verification: {
    registration: 'Registration'
  },
  ViewSelection: {
    COURSES: 'Content',
    GRADEBOOK: 'Grade Review',
    WORKSPACE: 'FileShare'
  },
  WeeklyPerformanceChart: {
    highColor: '#80bd44',
    lowColor: '#db2828',
    mediumColor: '#e3ad4b',
  }
};

export default translations;
